// extracted by mini-css-extract-plugin
export default {"bubbleModalContent":"BubbleModal__bubbleModalContent___rYP9q"};